import FormAjax from './../../../../front/static/src/tools/form.ajax.es6';

const PROPERTY_SEARCH_FORM = '#property_search_form';
const PROMO_SEARCH_FORM = '#promo_code_search_form';

if ($(PROPERTY_SEARCH_FORM).length) {
    if (window.location.href.includes('?test=1')) {
        $('[name="civic_no"]', $(PROPERTY_SEARCH_FORM)).val('2132');
        $('[name="suite"]', $(PROPERTY_SEARCH_FORM)).val('2');
        $('[name="street_name"]', $(PROPERTY_SEARCH_FORM)).val('Bourbonniere');
        $('[name="city"]', $(PROPERTY_SEARCH_FORM)).val('Montreal');
        $('[name="postal_code"]', $(PROPERTY_SEARCH_FORM)).val('h1w3p1');
    }

    new FormAjax($(PROPERTY_SEARCH_FORM), (response, e) => {
        window.location.replace(response['redirect_url']);

    });
}
if ($(PROMO_SEARCH_FORM).length) {
    new FormAjax($(PROMO_SEARCH_FORM), (response, e) => {
        window.location.replace(response['redirect_url']);
    });
}